
export const LOGIN_ATTEMPT = "LOGIN_ATTEMPT";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";

export const LOGOUT = "LOGOUT";

export const RESET_SUCCESS = "RESET_SUCCESS";
export const UPDATE_FAILED = "UPDATE_FAILED";


export const UPDATE_SUCCESS = "UPDATE_SUCCESS";

export const SESSION_BOOTSTRAP_DONE = "SESSION_BOOTSTRAP_DONE";
export const SESSION_HYDRATE = "SESSION_HYDRATE";

